class ProductTemplate extends HTMLElement {
    constructor() {
        function t(t, e, r, a) {
            void 0 === e && (e = 400),
                void 0 === a && (a = !1),
                (t.style.overflow = "hidden"),
                a && (t.style.display = "block");
            var i,
                o = window.getComputedStyle(t),
                n = parseFloat(o.getPropertyValue("height")),
                s = parseFloat(o.getPropertyValue("padding-top")),
                l = parseFloat(o.getPropertyValue("padding-bottom")),
                c = parseFloat(o.getPropertyValue("margin-top")),
                d = parseFloat(o.getPropertyValue("margin-bottom")),
                u = n / e,
                p = s / e,
                h = l / e,
                m = c / e,
                y = d / e;
            window.requestAnimationFrame(function o(v) {
                void 0 === i && (i = v),
                    (v -= i),
                    a
                        ? ((t.style.height = u * v + "px"),
                          (t.style.paddingTop = p * v + "px"),
                          (t.style.paddingBottom = h * v + "px"),
                          (t.style.marginTop = m * v + "px"),
                          (t.style.marginBottom = y * v + "px"))
                        : ((t.style.height = n - u * v + "px"),
                          (t.style.paddingTop = s - p * v + "px"),
                          (t.style.paddingBottom = l - h * v + "px"),
                          (t.style.marginTop = c - m * v + "px"),
                          (t.style.marginBottom = d - y * v + "px")),
                    e <= v
                        ? ((t.style.height = ""),
                          (t.style.paddingTop = ""),
                          (t.style.paddingBottom = ""),
                          (t.style.marginTop = ""),
                          (t.style.marginBottom = ""),
                          (t.style.overflow = ""),
                          a || (t.style.display = "none"),
                          "function" == typeof r && r())
                        : window.requestAnimationFrame(o);
            });
        }
        super(),
            (this.modal = document.getElementById("myModal")),
            Fancybox.bind(),
            Fancybox.close(),
            (HTMLElement.prototype.slideToggle = function (e, r) {
                0 === this.clientHeight ? t(this, e, r, !0) : t(this, e, r);
            }),
            (HTMLElement.prototype.slideUp = function (e, r) {
                t(this, e, r);
            }),
            (HTMLElement.prototype.slideDown = function (e, r) {
                t(this, e, r, !0);
            }),
            this.initEventListener(),
            this.querySelectorAll(".product__variants input").forEach((t) => {
                t.addEventListener("click", this.updateVariant.bind(this));
            }),
            this.querySelector(".product__form form") &&
                this.querySelector(".product__form form").addEventListener(
                    "submit",
                    this.addToCartMain.bind(this)
                ),
            this.querySelectorAll(".product-quantity__button").forEach((t) => {
                t.classList.contains("product-quantity__button-minus")
                    ? t.addEventListener(
                          "click",
                          this.decreaseQunatity.bind(this)
                      )
                    : t.addEventListener(
                          "click",
                          this.increaseQunatity.bind(this)
                      );
            }),
            this.querySelector(".product-count") &&
                (this.variantQuantity = Number(
                    this.querySelector(".product-count").value
                )),
            (this.swiperType = new Swiper(
                this.querySelector(".swiper-product"),
                {
                    direction: "horizontal",
                    loop: !1,
                    slidesPerView: "auto",
                    initialSlide: 0,
                    pagination: {
                        el: this.querySelector(
                            ".swiper-product .swiper-pagination"
                        ),
                    },
                }
            ));
    }
    updateVariant(t) {
        const e = document.querySelector(
            "input:checked + label [data-variant-color-clean]"
        ).innerHTML;
        (this.variantQuantity = 1),
            this.querySelectorAll(".product-quantity__button").forEach((t) => {
                t.classList.remove("disable");
            }),
            this.querySelector(".stock_empty").classList.add("hidden"),
            (this.querySelector(".product-count").value = 1),
            document
                .querySelectorAll(".product__images-desk  img")
                .forEach((t) => {
                    t.classList.add("hidden"),
                        t.alt.toLowerCase() == e &&
                            t.classList.remove("hidden");
                }),
            document.querySelectorAll(".slider__image").forEach((t) => {
                t.classList.add("hidden");
                const r = t.querySelector("img").alt.toLowerCase();
                t.classList.remove("swiper-slide"),
                    r == e &&
                        (t.classList.add("swiper-slide"),
                        t.classList.remove("hidden"));
            }),
            (document.querySelector("html").scrollTop = 0),
            this.swiperType.update(),
            this.swiperType.slideTo(0);
    }
    initEventListener() {
        this.querySelectorAll(".tab-item-title").forEach((t) => {
            t.addEventListener("click", this.toggletabItem.bind(this));
        });
    }
    toggletabItem(t) {
        t.currentTarget
            .querySelector(".tab-close")
            .classList.toggle("tab-display-none");
        t.currentTarget.parentNode
            .querySelector(".tab-item-text")
            .slideToggle("250");
    }
    addToCartMain(t) {
        t.preventDefault(),
            (this.productQuantity =
                t.currentTarget.parentNode.querySelector(
                    ".product-count"
                ).value),
            (this.variantId =
                t.currentTarget.parentNode.querySelector('[name="id"]').value),
            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: this.variantId.toString(),
                    quantity: Number(this.productQuantity),
                }),
            })
                .then((t) => t.json())
                .then((t) => {
                    document
                        .querySelector(".add_to_cart")
                        .classList.remove("hidden"),
                        fetch("/cart.js", {
                            method: "GET",
                            headers: { "Content-Type": "application/json" },
                        })
                            .then((t) => t.json())
                            .then((t) => {
                                window.dispatchEvent(
                                    new CustomEvent("cart:added", { detail: t })
                                ),
                                    document
                                        .querySelector(
                                            ".header-icons .cart-item-count-header"
                                        )
                                        .classList.remove("hidden"),
                                    document
                                        .querySelector(
                                            ".header--mobile-cart-quantity .cart-item-count-header"
                                        )
                                        .classList.remove("hidden"),
                                    (document.querySelector(
                                        ".header-icons .cart-item-count-header"
                                    ).textContent = t.item_count),
                                    (document.querySelector(
                                        ".header--mobile-cart-quantity .cart-item-count-header"
                                    ).textContent = t.item_count),
                                    typeof window.wetheme !== "undefined" && typeof window.wetheme.updateCartDrawer === "function" && window.wetheme.updateCartDrawer(t),
                                    document.querySelector(
                                        '[aria-controls="cartSlideoutAside"]'
                                    ) &&
                                        document
                                            .querySelector(
                                                '[aria-controls="cartSlideoutAside"]'
                                            )
                                            .click();
                            }),
                        setTimeout(() => {
                            document
                                .querySelector(".add_to_cart")
                                .classList.add("hidden");
                        }, 4e3);
                });
    }
    decreaseQunatity(t) {
        this.querySelector(".product-quantity__button-plus").classList.remove(
            "disable"
        ),
            this.variantQuantity >=
                Number(
                    document.querySelector("[data-variant-quantity]").innerHTML
                ) && this.querySelector(".stock_empty").classList.add("hidden"),
            1 == this.variantQuantity
                ? this.querySelector(
                      ".product-quantity__button-minus"
                  ).classList.add("disable")
                : ((this.variantQuantity -= 1),
                  this.querySelectorAll(".product-count").forEach((t) => {
                      t.value = this.variantQuantity;
                  }));
    }
    increaseQunatity(t) {
        this.variantQuantity >=
        Number(document.querySelector("[data-variant-quantity]").innerHTML)
            ? (this.querySelector(
                  ".product-quantity__button-plus"
              ).classList.add("disable"),
              this.querySelector(".stock_empty").classList.remove("hidden"))
            : (1 == this.variantQuantity &&
                  this.querySelector(
                      ".product-quantity__button-minus"
                  ).classList.remove("disable"),
              (this.variantQuantity += 1),
              this.querySelectorAll(".product-count").forEach((t) => {
                  t.value = Number(this.variantQuantity);
              }));
    }
}
customElements.define("product-template", ProductTemplate);
class VariantSelects extends HTMLElement {
    constructor() {
        super(),
            this.getCurrentColor(),
            this.updateUnavailableSelectors(),
            this.addEventListener("change", this.onVariantChange),
            document.querySelectorAll(
                ".template-product .product__details [data-variant-color]"
            );
    }
    onVariantChange() {
        this.updateUnavailableSelectors(),
            this.updateOptions(),
            this.updateMasterId(),
            this.removeErrorMessage(),
            this.currentVariant
                ? (this.updateURL(),
                  this.updateVariantInput(),
                  this.renderProductInfo())
                : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }
    getCurrentColor() {
        var t,
            e,
            r,
            a =
                ((t = "data-color"),
                (e = null),
                (r = []),
                location.search
                    .substr(1)
                    .split("&")
                    .forEach(function (a) {
                        (r = a.split("="))[0] === t &&
                            (e = decodeURIComponent(r[1]));
                    }),
                e);
        if (a) {
            var i = a.toLowerCase();
            document.querySelector('[data-variant-color="' + i + '"]').click();
        }
    }
    updateUnavailableSelectors() {
        if (
            (document.querySelectorAll("[data-variant-color]").forEach((t) => {
                t.classList.remove("unavailable");
            }),
            document.querySelector("#unavailable-variants"))
        ) {
            const i = document
                .querySelector("#unavailable-variants")
                .value.split(" , ");
            var t = [],
                e = [];
            for (const r in i) {
                i[r].split(" / ").length > 1
                    ? (e.push(i[r].split(" / ")[1]),
                      t.push(i[r].split(" / ")[0]))
                    : t.push(i[r].split(" / ")[0]);
            }
            var r = !1;
            for (const t in e)
                ("XS" != e[t] && "S" != e[t] && "XL" != e[t]) || (r = !0);
            if (r) {
                var a = t;
                (t = e), (e = a);
            }
            document
                .querySelector('[name="color"]:checked + label')
                .getAttribute("data-variant-color");
            document.querySelectorAll('[name="taille"][value]').forEach((t) => {
                t.classList.remove("unavailable");
            });
        }
    }
    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll("select"),
            (t) => t.value
        );
        var t = Array.from(
                this.closest(".product__info-container").querySelectorAll(
                    "fieldset"
                )
            ),
            e = this.options.concat(
                t.map(
                    (t) =>
                        Array.from(t.querySelectorAll("input")).find(
                            (t) => t.checked
                        ).value
                )
            );
        this.options = e;
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
        );
    }
    updateURL() {
        if (!this.currentVariant || "false" === this.dataset.updateUrl) return;
        let t = "";
        window.location.href.indexOf("view=pro") > -1 && (t = "&view=pro"),
            window.history.replaceState(
                {},
                "",
                `${this.dataset.url}?variant=${this.currentVariant.id}${t}`
            );
    }
    updateShareUrl() {
        const t = document.getElementById(`Share-${this.dataset.section}`);
        t &&
            t.updateUrl(
                `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
            );
    }
    updateVariantInput() {
        document
            .querySelectorAll(
                `#product-form-${this.dataset.section}, #product-form-installment`
            )
            .forEach((t) => {
                const e = t.querySelector('input[name="id"]');
                (e.value = this.currentVariant.id),
                    e.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
    }
    removeErrorMessage() {
        const t = this.closest("section");
        if (!t) return;
        const e = t.querySelector("product-form");
        e && e.handleErrorMessage();
    }
    renderProductInfo() {
        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        )
            .then((t) => t.text())
            .then((t) => {
                const e = new DOMParser().parseFromString(t, "text/html"),
                    r = e.querySelector(
                        ".product-form__input .form__label span"
                    ),
                    a = document.querySelector(
                        ".product-form__input .form__label span"
                    ),
                    i = e.querySelector(".product__details .price__container"),
                    o = document.querySelector(
                        ".product__details .price__container"
                    ),
                    n = e.querySelector("[data-variant-quantity]"),
                    s = document.querySelector("[data-variant-quantity]");
                (o.innerHTML = i.innerHTML),
                    (s.innerHTML = n.innerHTML),
                    (a.innerHTML = r.innerHTML),
                    this.toggleAddButton(
                        !this.currentVariant.available,
                        "RUPTURE DE STOCK"
                    );
            });
    }
    toggleAddButton(t = !0, e, r = !0) {
        const a = document.getElementById(
            `product-form-${this.dataset.section}`
        );
        if (!a) return;
        const i = a.querySelector('[name="add"]'),
            o = a.querySelector('[name="add"] > span');
        i &&
            (t
                ? (i.setAttribute("disabled", "disabled"),
                  e && (o.textContent = e))
                : (i.removeAttribute("disabled"),
                  (o.textContent = "AJOUTER AU PANIER")));
    }
    setUnavailable() {
        const t = document.getElementById(
                `product-form-${this.dataset.section}`
            ),
            e = t.querySelector('[name="add"]'),
            r = t.querySelector('[name="add"] > span'),
            a = document.getElementById(`price-${this.dataset.section}`);
        e &&
            ((r.textContent = window.variantStrings.unavailable),
            a && a.classList.add("visibility-hidden"));
    }
    getVariantData() {
        return (
            (this.variantData =
                this.variantData ||
                JSON.parse(
                    this.querySelector('[type="application/json"]').textContent
                )),
            this.variantData
        );
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptions() {
        const t = Array.from(this.querySelectorAll("fieldset"));
        this.options = t.map(
            (t) =>
                Array.from(t.querySelectorAll("input")).find((t) => t.checked)
                    .value
        );
        var e = Array.from(
            this.closest(".product__details").querySelectorAll("select"),
            (t) => t.value
        ).concat(this.options);
        this.options = e;
    }
}
customElements.define("variant-radios", VariantRadios);
